import { render, staticRenderFns } from "./AddTemplateModal.vue?vue&type=template&id=143b77c2&scoped=true&"
import script from "./AddTemplateModal.vue?vue&type=script&lang=js&"
export * from "./AddTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTemplateModal.vue?vue&type=style&index=0&id=143b77c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143b77c2",
  null
  
)

export default component.exports